import React from "react";

const ITEMS = [
  "Brand Identity", "Digital Marketing", "Meta Ads", "Google Ads",
  "Website Design", "E-commerce", "Social Media", "Content Production",
  "SEO", "Campaign Strategy", "Brand Films", "Growth Systems",
];

export default function Marquee() {
  const repeated = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="marquee-section" aria-hidden="true">
      <div className="marquee-track">
        {repeated.map((item, i) => (
          <span className="marquee-item" key={i}>
            {item}
            <span className="marquee-dot">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
